module.exports = __webpack_public_path__ + "officialStatic/img/solution-detail-bg.6205680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-detail-bg.png
// module id = YeZ/
// module chunks = 0